export const POS_VIEW_EDITOR = 'editor';
export const POS_VIEW_CLIENT = 'client';

export const POS_VIEW_OPTIONS = [
  { value: POS_VIEW_EDITOR, label: 'Editor' },
  { value: POS_VIEW_CLIENT, label: 'Cliente' },
];

export const normalizePosView = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === POS_VIEW_CLIENT) return POS_VIEW_CLIENT;
  return POS_VIEW_EDITOR;
};

export const buildPosViewSearchParams = (searchParams, nextView) => {
  const next = new URLSearchParams(searchParams);
  const normalizedView = normalizePosView(nextView);
  if (normalizedView === POS_VIEW_EDITOR) {
    next.delete('posView');
  } else {
    next.set('posView', normalizedView);
  }
  return next;
};

const normalizeWindowKeyPart = (value) => {
  const normalized = String(value || '').trim();
  return normalized || 'na';
};

export const buildPosWindowName = ({
  branchId,
  cashRegisterId,
  cashRegisterSessionId,
  mode,
}) => [
  'pos',
  normalizeWindowKeyPart(branchId),
  normalizeWindowKeyPart(cashRegisterId),
  normalizeWindowKeyPart(cashRegisterSessionId),
  normalizePosView(mode),
].join(':');
